export default "__VITE_ASSET__F1U4HCjd__"